/* Raquex PDP test (Option B): dispatch countdown and price in the CTA.
   Fails silent. If anything here throws, the page keeps the theme's
   default button label and a static dispatch line. */
(function () {
  'use strict';

  // Loaded by the PDP's rqx_dispatch block AND by cart-footer, which renders
  // the same strip in the cart drawer on every page. Same asset_url either
  // way, so the browser fetches it once, but the IIFE would still run twice
  // and double up the interval and the observer.
  if (window.__rqxPdpInit) { return; }
  window.__rqxPdpInit = true;

  /* ---------- dispatch countdown and delivery date ---------- */
  // Parts of "now" as they are in London, whatever the viewer's timezone.
  // The date parts matter as much as the clock: the delivery date is counted
  // in London days, so a viewer in Sydney or Los Angeles is told the same
  // date as a viewer in Worcester.
  function londonNow() {
    var f = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London', weekday: 'short',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
    });
    var p = {};
    f.formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return {
      day: p.weekday,
      y: parseInt(p.year, 10),
      mo: parseInt(p.month, 10),
      d: parseInt(p.day, 10),
      h: parseInt(p.hour, 10) % 24,
      m: parseInt(p.minute, 10),
      s: parseInt(p.second, 10)
    };
  }

  var DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  var NEXT = { Fri: 'Monday', Sat: 'Monday', Sun: 'Monday',
               Mon: 'tomorrow', Tue: 'tomorrow', Wed: 'tomorrow', Thu: 'tomorrow' };

  // Midnight UTC on the London calendar date. Day arithmetic happens on this
  // anchor, so no local timezone can shift the result across a date boundary.
  function anchor(t) { return new Date(Date.UTC(t.y, t.mo - 1, t.d)); }
  function addDays(base, n) { return new Date(base.getTime() + n * 86400000); }
  function dow(date) { return date.getUTCDay(); }           // 0 Sun .. 6 Sat
  function isWeekend(date) { var w = dow(date); return w === 0 || w === 6; }

  function t(el, name, fallback) {
    var v = el && el.getAttribute('data-t-' + name);
    return v && v.length ? v : fallback;
  }
  // Date names must follow the shopper's language too, or a translated sentence
  // ends on an English weekday. Falls back to en-GB if the attribute is absent.
  function longFmt(el) {
    var loc = (el && el.getAttribute('data-locale')) || 'en-GB';
    // Shopify hands back a bare 'en', and Intl reads that as American, turning
    // "Thursday 22 October" into "Thursday, October 22" on the UK store. This is
    // a British shop, so bare English means en-GB.
    if (loc === 'en') loc = 'en-GB';
    try {
      return new Intl.DateTimeFormat(loc, {
        timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long'
      });
    } catch (e) {
      return new Intl.DateTimeFormat('en-GB', {
        timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long'
      });
    }
  }
  var LONG = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long'
  });
  var SHORT = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short'
  });

  // The working day the order leaves us on.
  function dispatchDate(now, cutoff) {
    var base = anchor(now);
    if (!isWeekend(base) && now.h < cutoff) return base;
    var d = addDays(base, 1);
    while (isWeekend(d)) d = addDays(d, 1);
    return d;
  }

  // Next-day service: the day after dispatch, unless that is a day the
  // carrier will not deliver. Saturday is a delivery day only for the light
  // carrier; anything heavy goes FedEx, which rolls Saturday to Monday.
  function nextDayArrival(dispatch, saturdayOk) {
    var a = addDays(dispatch, 1);
    if (dow(a) === 6 && !saturdayOk) return addDays(a, 2);
    if (dow(a) === 0) return addDays(a, 1);
    return a;
  }

  // Which variant is selected right now, so a heavier variant re-decides
  // Saturday. Falls back to the weight rendered by Liquid.
  function currentWeight(el) {
    var fallback = parseInt(el.getAttribute('data-weight') || '0', 10);
    try {
      var map = JSON.parse(el.getAttribute('data-weights') || '{}');
      var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
      var id = input && input.value;
      if (!id) {
        var q = new URLSearchParams(window.location.search).get('variant');
        if (q) id = q;
      }
      if (id && Object.prototype.hasOwnProperty.call(map, id)) return map[id];
    } catch (e) {}
    return fallback;
  }

  function renderDispatch(el) {
    var cutoff = parseInt(el.getAttribute('data-cutoff') || '16', 10);
    var satMax = parseInt(el.getAttribute('data-sat-max') || '450', 10);
    var now = londonNow();
    var isWeekday = DAYS.indexOf(now.day) > -1 && DAYS.indexOf(now.day) < 5;
    var slot = el.querySelector('[data-rqx-dispatch-text]');
    var dslot = el.querySelector('[data-rqx-delivery-text]');

    if (slot) {
      if (isWeekday && now.h < cutoff) {
        var left = (cutoff * 3600) - (now.h * 3600 + now.m * 60 + now.s);
        var hh = Math.floor(left / 3600);
        var mm = Math.floor((left % 3600) / 60);
        var clock = hh > 0 ? hh + 'h ' + mm + 'm' : mm + 'm';
        var tpl = t(el, 'order-in', 'Order in {time} for same-day dispatch');
        slot.innerHTML = tpl.replace('{time}', '<span class="rqx-dispatch__time"></span>');
        var ts = slot.querySelector('.rqx-dispatch__time');
        if (ts) { ts.textContent = clock; } else { slot.textContent = tpl.replace('{time}', clock); }
      } else {
        slot.textContent = (NEXT[now.day] === 'tomorrow')
          ? t(el, 'dispatch-tomorrow', 'Order now for dispatch tomorrow')
          : t(el, 'dispatch-on', 'Order now for dispatch on {day}')
              .replace('{day}', t(el, 'monday', 'Monday'));
      }
    }

    if (dslot) {
      var weight = currentWeight(el);
      var saturdayOk = !(weight >= satMax);
      var disp = dispatchDate(now, cutoff);
      var arrive = nextDayArrival(disp, saturdayOk);
      // "as soon as" because this is the FASTEST option (Next Day Guaranteed,
      // paid). A buyer choosing free standard gets a later date, so the copy
      // must not read as a promise for every option.
      var dtpl = t(el, 'get-by', 'Get it as soon as: {date}');
      dslot.innerHTML = dtpl.replace('{date}', '<b></b>');
      var db = dslot.querySelector('b');
      if (db) { db.textContent = longFmt(el).format(arrive); }
      else { dslot.textContent = dtpl.replace('{date}', longFmt(el).format(arrive)); }
    }
  }

  function renderAll() {
    // Re-queried every tick on purpose: the cart drawer is replaced wholesale
    // when the cart changes, so a list captured once would go stale and the
    // countdown would freeze on the new markup.
    var els = document.querySelectorAll('[data-rqx-dispatch]');
    Array.prototype.forEach.call(els, renderDispatch);
  }

  function startDispatch() {
    renderAll();
    setInterval(renderAll, 30000);
  }

  /* ---------- price in the add to cart button ---------- */
  function priceText() {
    var el = document.querySelector('.product-price .price-item--regular, .product-price .price-item--sale, .product-price');
    if (!el) return null;
    var m = (el.textContent || '').match(/[£$€]\s?[\d,]+(?:\.\d{2})?/);
    return m ? m[0].replace(/\s/g, '') : null;
  }

  function syncButton() {
    // This theme's buttons carry no name="add". The shared hook is
    // .add-to-cart, which also catches the sticky bar's button.
    var btns = document.querySelectorAll('.add-to-cart');
    if (!btns.length) return;
    var p = priceText();
    Array.prototype.forEach.call(btns, function (btn) {
      var span = btn.querySelector('[data-rqx-cta-label]');
      if (!span) {
        span = document.createElement('span');
        span.setAttribute('data-rqx-cta-label', '');
        btn.appendChild(span);
      }
      // Suppressed while the variant is unavailable: the theme swaps the
      // label to "Sold out" and a price beside it would read as a bug.
      var label = (btn.textContent || '').replace(span.textContent, '');
      var sold = /sold\s*out|unavailable/i.test(label);
      span.textContent = (p && !sold) ? ' · ' + p : '';
    });
  }

  function start() {
    try { startDispatch(); } catch (e) {}
    try { syncButton(); } catch (e) {}
    try {
      // Variant pickers re-render the price node, so watch the document
      // rather than guessing at this theme's custom events. The same tick
      // re-runs the delivery date, which depends on the selected variant's
      // weight.
      if (window.MutationObserver) {
        var pending = null;
        new MutationObserver(function () {
          clearTimeout(pending);
          pending = setTimeout(function () {
            try { syncButton(); } catch (e) {}
            try { renderAll(); } catch (e) {}
          }, 120);
        }).observe(document.body, { childList: true, subtree: true, characterData: true });
      }
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
